// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const PipCodeType = t.list(KeyValuePair, 'PipCodeType');

export const getDefaultState = () => [];

export default PipCodeType;



// WEBPACK FOOTER //
// ./src/pip/pip-code/state/pip-code-type.js